import { Component, OnInit } from "@angular/core";
import {
    FormControl,
    ReactiveFormsModule,
    Validators,
    FormGroup,
} from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import PasswordConfirm from "./../../../_app-core/_utils/password-match";
import { AuthService } from "src/app/_app-core/services/auth/auth.service";

@Component({
    selector: "app-reset-password",
    templateUrl: "./reset-password.component.html",
    styleUrls: ["./reset-password.component.scss"],
})
export class ResetPasswordComponent implements OnInit {
    isLoading = false;
    isError = false;
    responseData: any;
    isSuccess = false;

    username: any;
    token: any;

    resetData = new FormGroup(
        {
            // oldPassword: new FormControl(null, Validators.required),
            newPassword: new FormControl(null, [
                Validators.required,
                Validators.minLength(8),
                Validators.maxLength(15),
                // Validators.pattern(
                //   '^(?=.*[0-9])(?=.*[a-z])(?=.*[*.!@$%^&(){}[]:;<>,.?/~_+-=|]).{8}$'
                // ),
            ]),
            confirmPassword: new FormControl(null, Validators.required),
        },
        {
            validators: [
                PasswordConfirm.match("newPassword", "confirmPassword"),
            ],
        }
    );
    constructor(
        private router: Router,
        private http: HttpClient,
        private route: ActivatedRoute,
        private authService: AuthService
    ) {
        this.route.queryParams.subscribe((params) => {
            if (params["token"]) {
                const pathParams = params["token"];
                let pathSplit = pathParams.split("@");
                //console.log(pathSplit);
                this.token = pathSplit[0];
                this.username = pathSplit[1];
            } else {
                this.router.navigateByUrl("/");
            }
        });
    }

    onPasswordReset() {
        this.isLoading = true;
        const passwordData = {
            username: this.username,
            password1: this.resetData.value.newPassword,
            password2: this.resetData.value.confirmPassword,
            q1: " ",
            a1: " ",
            q2: " ",
            a2: " ",
            reqType: "forgot"
        };

        this.authService.resetPassword(passwordData).subscribe(
            (res) => {
                this.responseData = res;
                if (this.responseData.status == "success") {
                    this.isLoading = false;
                    this.isSuccess = true;
                    // setTimeout(() => {
                    //   this.router.navigateByUrl('/sign-in');
                    // }, 4000);
                } else {
                    this.isError = true;
                    console.log(res);
                }
            },
            (error) => {
                this.isError = true;
            }
        );
    }

    ngOnInit(): void {}
}
